module.exports = __webpack_public_path__ + "img/laminate_three.5b505e62.png";